var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSkladniki = function SvgSkladniki(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st11{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M18.7,4.5C17.6,1.8,15,0,12.1,0S6.6,1.8,5.5,4.6C5.4,4.6,5.2,4.7,5,4.8C4.4,5,4.2,5.1,4,5.2 C3.4,5.6,2.9,6.1,2.3,6.8l0,0C1.4,8,0.9,9.5,0.9,11.1c0,3.2,2.2,6,5.3,6.8c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.3,0.8-0.6 c0.1-0.4-0.2-0.9-0.6-1c-2.4-0.6-4.1-2.7-4.1-5.2c0-1.2,0.4-2.3,1.1-3.3C4,7.3,4.5,6.9,4.9,6.6l0,0C5,6.5,5.4,6.4,5.6,6.3 c1-0.4,1.3-0.5,1.4-0.9c0.7-2.2,2.8-3.7,5.1-3.7c2.4,0,4.4,1.5,5.1,3.8C17.3,5.8,17.5,6,17.7,6c2.2,0.7,3.8,2.8,3.8,5.1 c0,2.4-1.6,4.5-4,5.2c-0.4,0.1-0.7,0.6-0.6,1s0.6,0.7,1,0.6c3.1-0.8,5.2-3.6,5.2-6.8C23.2,8.2,21.3,5.5,18.7,4.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M17.6,16.3c-0.5,0-0.8,0.4-0.8,0.8v5.2H7.2v-5.2c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8v6 C5.6,23.6,6,24,6.4,24h11.2c0.5,0,0.8-0.4,0.8-0.8v-6C18.5,16.7,18.1,16.3,17.6,16.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M17.6,19H6.4c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h11.2c0.5,0,0.8-0.4,0.8-0.8 C18.5,19.4,18.1,19,17.6,19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12,5.6c-0.5,0-0.8,0.4-0.8,0.8v8.9c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8V6.5 C12.8,6,12.5,5.6,12,5.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M15.1,8.8c-0.5,0-0.8,0.4-0.8,0.8v5.8c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8V9.6 C15.9,9.1,15.6,8.8,15.1,8.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M8.9,8.8c-0.5,0-0.8,0.4-0.8,0.8v5.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8V9.6 C9.7,9.1,9.4,8.8,8.9,8.8z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkladniki, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skladniki.c8b44c3f.svg";
export { ForwardRef as ReactComponent };